import { render, staticRenderFns } from "./GameCell.vue?vue&type=template&id=1694c7ce&scoped=true&"
import script from "./GameCell.vue?vue&type=script&lang=js&"
export * from "./GameCell.vue?vue&type=script&lang=js&"
import style0 from "./GameCell.vue?vue&type=style&index=0&id=1694c7ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1694c7ce",
  null
  
)

export default component.exports